// extracted by mini-css-extract-plugin
export default {"root":"ConfirmAcceptApplicationModal_root__Ovo6F","sub-header":"ConfirmAcceptApplicationModal_sub-header__Hk8cW"};